import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BehaviorSubject } from 'rxjs';
import { ClaimsService } from './claims.service';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.scss'],
})
export class ClaimsComponent implements OnInit {
  responseData: any;

  constructor(
    protected service: ClaimsService,
    protected routingService: RoutingService,
    private userAccount: UserAccountFacade,
    public router: Router
  ) {}
  /** A hero's name can't match the given regular expression */
  onlyCommaAndNumbers(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = nameRe.test(control.value);
      return !forbidden ? { onlyComma: { value: control.value } } : null;
    };
  }
  maxCharacterLimit(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && control.value.length > 255
        ? { maxCharExceeded: { value: control.value } }
        : null;
    };
  }

  onlyFiveInvoices(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let invoices = control.value ? control.value.split(',') : [];
      //return !forbidden ? {onlyComma: {value: control.value}} : null;
      return invoices.length > 5
        ? { maxFixInvoice: { value: control.value } }
        : null;
    };
  }
  properemailformat(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = nameRe.test(control.value);
      return !forbidden ? { emailformat: { value: control.value } } : null;
    };
  }
  form: FormGroup = new FormGroup({
    invoiceNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(80),
      this.onlyCommaAndNumbers(/^[0-9,]+$/),
      this.onlyFiveInvoices(),
    ]),
    name: new FormControl(''),
    email: new FormControl('', [
      this.properemailformat(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ),
    ]),
    categoryType: new FormControl(''),
    categorySubType: new FormControl(''),
    termsAndConditions: new FormControl(''),
    claimedValue: new FormControl(''),
    subject: new FormControl(''),
    description: new FormControl('', [this.maxCharacterLimit()]),
  });
  isUpdating: boolean = false;
  claimsSuccess: any = false;
  testEmitter$ = new BehaviorSubject<string>(this.claimsSuccess);
  userData: any;
  privacyPath: any ;
  categoryTypes: Array<Object> = [
    {
      code: 'ET_IC_CLM_01',
      label: 'Off-invoice Pricing Claim',
    },
    {
      code: 'ET_IC_CLM_02',
      label: 'On-invoice Pricing Claim',
    },
    {
      code: 'ET_IC_CLM_03',
      label: 'Goods Claim',
    },
  ];
  categorySubTypes: Array<Object> = [
    {
      ET_IC_CLM_01: [
        {
          code: 'ET_CC_CLM_01',
          label: 'Promotional Claim',
        },
        {
          code: 'ET_CC_CLM_02',
          label: 'Yearly contract payment',
        },
        {
          code: 'ET_CC_CLM_03',
          label: 'Penalties',
        },
        {
          code: 'ET_CC_CLM_04',
          label: 'Additional',
        },
      ],
    },
    {
      ET_IC_CLM_02: [
        {
          code: 'ET_CC_CLM_05',
          label: 'On-invoice Pricing Claim',
        },
      ],
    },
    {
      ET_IC_CLM_03: [
        {
          code: 'ET_CC_CLM_06',
          label: 'Delivery discrepancy',
        },
        {
          code: 'ET_CC_CLM_07',
          label: 'Damaged goods',
        },
        {
          code: 'ET_CC_CLM_08',
          label: 'Quality issue',
        },
        {
          code: 'ET_CC_CLM_09',
          label: 'Return request',
        },
        {
          code: 'ET_CC_CLM_10',
          label: 'Refusal',
        },
      ],
    },
  ];
  selectedCause: Array<any> = [];
  name: any = '';
  id: any = '';
  sitecountry: any = '';
  selectCause(categoryTypeData: any) {
    let options = this.categorySubTypes.map((op: any) => {
      const key = Object.keys(op)[0];

      if (key === categoryTypeData.value) {
        return {
          value: Object.keys(op)[0],
          items: op[key],
        };
      } else {
        return null;
      }
    });
    
    let causes = options.filter((element): element is any => {
      return element !== null;
    });
    
    this.selectedCause = causes && causes.length ? causes[0].items : null;
  }
  goBackHome(): void {
    this.routingService.go({
      cxRoute: 'home',
    });
  }
  onSubmit(): void {
    this.isUpdating = true;
    let reqFormData = this.form.controls;

    //this.service.login();
    let requestBody: any;
    requestBody = {
      claimCauseCategory: reqFormData.categorySubType.value,
      claimIncidentCategory: reqFormData.categoryType.value,
      claimSubject: reqFormData.subject.value,
      claimValue: reqFormData.claimedValue.value,
      contactEmail: reqFormData.email.value,
      contactName: reqFormData.name.value,
      description: reqFormData.description.value,
      invoiceIds: reqFormData.invoiceNumber.value.toString(),
    };
    this.service.createClaim(requestBody, this.userData).subscribe(
      (resp) => {
        this.form.reset();
        this.isUpdating = false;
        this.id = resp.id;
        this.claimsSuccess = true;
      },
      () => {
        this.claimsSuccess = true;
        this.testEmitter$.next(this.claimsSuccess);
      }
    );
  }

  goBack(): void {
    this.userAccount.get().subscribe((resp) => {
      if (resp) {
        this.userData = resp;
        this.form.setValue({
          invoiceNumber: '',
          name: resp.name,
          email: resp.uid,
          categoryType: '',
          categorySubType: '',
          termsAndConditions: false,
          claimedValue: '',
          subject: '',
          description: ''
        });
      }
    });
    this.claimsSuccess = false;
  }
  ngOnInit(): void {
    this.sitecountry = window.location.pathname.split('/');

    
    let path = window.location.pathname.split('/');
    let site = path[1];
    if(site === 'lipton-us'){
      this.privacyPath = "/lipton-us/en/USD/privacyPolicy";
    }else{
      this.privacyPath = "/lipton-pk/en/PKR/privacyPolicy";
    }
    this.userAccount.get().subscribe((resp) => {
      if (resp) {
        this.userData = resp;
        this.form.setValue({
          invoiceNumber: '',
          name: resp.name,
          email: resp.uid,
          categoryType: '',
          categorySubType: '',
          termsAndConditions: this.sitecountry[1] == 'lipton-pk' ? true : false,
          claimedValue: '',
          subject: '',
          description: '',
        });
      }
    });
  }
}
